<template>
  <section
    id="page-market"
    class="page"
  >
    <b-overlay
      :show="loading"
      no-center
      variant="transparent"
      rounded="sm"
    >
      <template #overlay>
        <loading-spinner />
      </template>
      <!-- ============ ELMAS PAKETLERI ============ -->
      <dynamic-market-invite />
      <div
        v-if="products.length"
        class="mk-section"
      >
        <div class="mk-header">
          <div class="mk-title-wrap">
            <span class="mk-cart">
              <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="url(#mkCartGrad)" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                <defs>
                  <linearGradient id="mkCartGrad" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#a855f7" />
                    <stop offset="1" stop-color="#6366f1" />
                  </linearGradient>
                </defs>
                <circle cx="9" cy="21" r="1.4" />
                <circle cx="19" cy="21" r="1.4" />
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
              </svg>
            </span>
            <span class="mk-title-bar" />
            <div>
              <h2 class="mk-title">
                {{ $t('Diamond Packages') }}
              </h2>
              <p class="mk-subtitle">
                {{ $t('Discover diamond packages to get the most out of Boho!') }}
              </p>
            </div>
          </div>

          <div class="mk-header-actions">
            <button
              type="button"
              class="mk-coupon-btn"
              @click="modalCouponCode = true"
            >
              <b-img
                :src="iconTicket"
                width="18"
                class="mk-coupon-icon"
              />
              {{ $t('Coupon') }}
            </button>
            <b-tooltip
              target="credits-tooltip"
              triggers="hover"
            >
              <p class="mb-0">
                {{ $t('Diamond - Used in Boho.') }}
              </p>
            </b-tooltip>
            <div
              id="credits-tooltip"
              class="mk-balance"
            >
              <b-img
                :src="iconDiamonds1"
                width="22"
              />
              <span class="mk-balance-amount">{{ numberFormat(credits || 0) }}</span>
              <span class="mk-balance-plus">
                <feather-icon
                  icon="PlusIcon"
                  size="14"
                />
              </span>
            </div>
          </div>
        </div>

        <div class="mk-grid">
          <template v-for="(product, index) in products">
            <router-link
              v-if="index >= 6 || minCredits <= product.credits"
              :key="product.productId"
              :to="generateProductLink(product.productId)"
              class="mk-card"
              :class="packageTheme(product, index)"
              @click.native="gtmSelectProduct(product.productId)"
            >
              <span
                v-if="product.credits === 1000"
                class="mk-popular"
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z" /></svg>
                {{ $t('Most Popular') }}
              </span>
              <span
                v-if="product.credits === 1000"
                class="mk-discount"
                v-html="$t('{rate} cheaper', { rate: `%${endsWithN(product.productId) ? 40 : 20}` })"
              />
              <span
                class="mk-card-glow"
                aria-hidden="true"
              />
              <div class="mk-gem">
                <b-img
                  :src="iconDiamonds3New2"
                  width="88"
                />
              </div>
              <div class="mk-amount">
                {{ numberFormat(product.credits) }}
                {{ couponCodeBonusRatio && product.credits >= 0 ? `+ ${numberFormat(product.credits * couponCodeBonusRatio)}` : null }}
                {{ $t('Diamonds') }}
              </div>
              <div class="mk-old-price">
                {{ (product.amount / (1 - (endsWithN(product.productId) ? 0.4 : 0.2))).toFixed(2) }}{{ currencySymbol(product.currency) }}
              </div>
              <div class="mk-price-btn">
                {{ product.amount }}{{ currencySymbol(product.currency) }}
              </div>
            </router-link>
          </template>
        </div>
      </div>

      <!-- ============ KAMPANYALAR ============ -->
      <div
        v-if="campaigns.length"
        class="mk-section"
      >
        <div class="mk-header">
          <div class="mk-title-wrap">
            <b-img
              :src="iconConfetti"
              width="40"
            />
            <span class="mk-title-bar pink" />
            <h2 class="mk-title">
              {{ $t('Campaigns') }}
            </h2>
          </div>
        </div>

        <div class="mk-campaign-grid">
          <router-link
            v-for="campaign in campaigns"
            :key="campaign.campaignId"
            :to="generateProductLink(campaign.webProduct, campaign.campaignId, campaign.campaignType)"
            class="mk-campaign"
          >
            <span
              class="mk-card-glow"
              aria-hidden="true"
            />
            <span
              v-if="campaign.campaignType === 'ONE_TIME_OFFER' && campaign.campaignCounter"
              class="mk-counter"
            >
              <feather-icon
                icon="ClockIcon"
                size="12"
              />
              <span v-if="campaign.campaignCounter.hours != '00'">
                {{ campaign.campaignCounter.hours }}:{{ campaign.campaignCounter.minutes }}:{{ campaign.campaignCounter.seconds }}
              </span>
              <span v-else>
                {{ campaign.campaignCounter.minutes }}:{{ campaign.campaignCounter.seconds }}
              </span>
            </span>
            <div class="mk-campaign-body">
              <div class="mk-gem small">
                <b-img
                  :src="iconDiamonds3New2"
                  width="64"
                />
              </div>
              <div class="mk-campaign-text-wrap">
                <h3 class="mk-campaign-title">
                  {{ campaign.campaignHeader }}
                </h3>
                <p class="mk-campaign-text">
                  {{ campaign.campaignText }}
                </p>
              </div>
            </div>
            <div class="mk-price-btn">
              <template v-if="userCountry !== 'TR'">
                {{ campaign.globalAmount }}$
              </template>
              <template v-else>
                {{ campaign.amount }}&#8378;
              </template>
            </div>
          </router-link>
        </div>
      </div>
      <!-- Message Packages - Temporarily disabled
      <b-row
        v-if="chatProducts.length"
        class="diamonds pl-05"
      >
        <b-col sm="12">
          <h2 class="market-title" style="padding-bottom: 12px; border-bottom: 1px solid #D6D6D6; margin-bottom: 18px">
            {{ $t('Message Packages') }}
          </h2>
        </b-col>
        <b-col
          v-for="chatProduct in chatProducts"
          :key="chatProduct.productId"
          class="product"
          xl="2"
          lg="3"
          md="4"
          sm="6"
          cols="6"
          @click="openBuyChatProduct(chatProduct)"
        >
          <b-card
            tag="div"
            class="diamond"
            style="padding: 10px 0"
          >
            <div class="diamond-header" style="margin-bottom: 12px">
              <b-img
                :src="iconChat5"
                height="36"
              />
            </div>
            <div class="diamond-body">
              <div class="diamond-piece" style="margin-bottom: 12px">
                {{ $t('{days} daily unlimited', {days: chatProduct.duration}) }}
              </div>
              <div class="diamond-price">
                <b-img :src="iconDiamonds3New2" height="18"/>
                {{ numberFormat(chatProduct.credits) }}
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      -->
      <b-row
        v-if="false"
        class="pl-05"
      >
        <b-col sm="12">
          <h2>
            {{ $t('Special Offer') }}
          </h2>
        </b-col>
        <b-col
          xl="3"
          lg="4"
          md="6"
          sm="6"
          cols="6"
        >
          <b-card
            tag="div"
            class="special-offer"
          >
            <div class="special-offer-header bg-1">
              <div class="special-offer-type">
                {{ $t('Subscription') }}
              </div>
              <div class="special-offer-description">
                {{ $t('See who likes you and more') }}...
              </div>
            </div>
            <div class="special-offer-body">
              <div class="special-offer-name">
                {{ $t('VIP Membership') }}
              </div>
              <div class="subscribe-button">
                {{ $t('Subscribe') }}
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col
          xl="3"
          lg="4"
          md="6"
          sm="6"
          cols="6"
        >
          <b-card
            tag="div"
            class="special-offer"
          >
            <div class="special-offer-header bg-2">
              <div class="special-offer-type">
                {{ $t('Subscription') }}
              </div>
              <div class="special-offer-description">
                {{ $t('See who likes you and more') }}...
              </div>
            </div>
            <div class="special-offer-body">
              <div class="special-offer-name">
                {{ $t('VIP Membership') }}
              </div>
              <div class="subscribe-button">
                {{ $t('Subscribe') }}
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row
        v-if="false"
        class="pl-05"
      >
        <b-col sm="12">
          <h2 class="mb-1">
            {{ $t('Subscription Packages') }}
          </h2>
        </b-col>
        <b-col
          xl="3"
          lg="4"
          md="6"
          sm="6"
          cols="6"
        >
          <b-card
            tag="div"
            class="subscription-package"
          >
            <div class="subscription-package-header">
              <div class="subscription-package-icon">
                <b-img :src="iconVip" />
              </div>
              <div class="subscription-package-text">
                <div class="subscription-package-title">
                  <span class="subscription-package-name">
                    {{ $t('VIP Membership') }}
                  </span>
                  <span class="subscription-package-period">
                    / 1 {{ $t('Month') }}
                  </span>
                </div>
                <div class="subscription-package-description">
                  {{ $t('This package is just for you to enjoy unlimited benefits') }}
                </div>
                <div class="mt-1 subscribe-button">
                  {{ $t('Subscribe') }}
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col
          xl="3"
          lg="4"
          md="6"
          sm="6"
          cols="6"
        >
          <b-card
            tag="div"
            class="subscription-package"
          >
            <div class="subscription-package-header">
              <div class="subscription-package-icon">
                <b-img :src="iconLounge" />
              </div>
              <div class="subscription-package-text">
                <div class="subscription-package-title">
                  <span class="subscription-package-name">
                    {{ $t('Lounge') }}
                  </span>
                  <span class="subscription-package-period">
                    / 1 {{ $t('Month') }}
                  </span>
                </div>
                <div class="subscription-package-description">
                  {{ $t('This package is just for you to enjoy unlimited benefits') }}
                </div>
                <div class="mt-1 subscribe-button">
                  {{ $t('Subscribe') }}
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col
          xl="3"
          lg="4"
          md="6"
          sm="6"
          cols="6"
        >
          <b-card
            tag="div"
            class="subscription-package"
          >
            <div class="subscription-package-header">
              <div class="subscription-package-icon">
                <b-img :src="iconDailyDiamond" />
              </div>
              <div class="subscription-package-text">
                <div class="subscription-package-title">
                  <span class="subscription-package-name">
                    {{ $t('Daily Diamond') }}
                  </span>
                  <span class="subscription-package-period">
                    / 1 {{ $t('Month') }}
                  </span>
                </div>
                <div class="subscription-package-description">
                  {{ $t('This package is just for you to enjoy unlimited benefits') }}
                </div>
                <div class="mt-1 subscribe-button">
                  {{ $t('Subscribe') }}
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>

    <b-modal
      v-if="selectedChatProduct"
      v-model="modalBuyChatProduct"
      centered
      hide-header-close
      hide-footer
      size="md"
    >
      <div class="buy-product-modal">
        <h4>
          {{ $t('You get {product} for {diamond} diamonds', {diamond: numberFormat(selectedChatProduct.credits), product: selectedChatProduct.description}) }}
        </h4>
        <b-button
          class="mt-2 px-4"
          variant="primary"
          size="sm"
          @click="buyChatProduct"
        >
          <b-spinner
            v-if="loading"
            small
          />
          {{ $t('Buy') }}
        </b-button>
      </div>
    </b-modal>

    <b-modal
      v-model="modalCouponCode"
      centered
      hide-header-close
      hide-footer
      hide-header
      size="sm"
    >
      <b-overlay
        :show="loading"
        no-center
        variant="transparent"
        rounded="sm"
      >
        <template #overlay>
          <loading-spinner />
        </template>
        <div
          class="d-flex justify-content-end fs-12 color-gray cursor-pointer"
          @click="modalCouponCode = false"
        >
          <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="7.85254" y="0.920044" width="2.85288" height="10.9225" rx="1.42644" transform="rotate(45 7.85254 0.920044)" fill="#D9D9D9"/>
            <rect x="10.0005" y="8.85925" width="2.73061" height="11.4115" rx="1.36531" transform="rotate(135 10.0005 8.85925)" fill="#D9D9D9"/>
          </svg>
        </div>
        <b-row class="password-information text-center mb-2">
          <b-col md="12">
            <div class="d-flex justify-content-center align-items-center flex-column pt-2 py-2">
              <h5 class="fs-22 fw-500 text-center color-black">
                <b-img :src="iconConfetti" width="40" />
                {{ $t('Use your coupon') }}!
                <b-img :src="iconConfetti" width="40" />
              </h5>
            </div>
          </b-col>
          <b-col sm="12">
            <validation-observer
              ref="form"
              #default="{invalid}"
            >
              <b-form @submit.prevent>
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Coupon Code')"
                    vid="code"
                    rules="required|min:4"
                  >
                    <b-input-group>
                      <b-form-input
                        v-model="couponCode"
                        name="couponCode"
                        style="border-radius: 24px; padding: 22px 14px; color: #28C76F;"
                        :loading="loading"
                        :placeholder="$t('Enter Your Coupon')"
                      />
                    </b-input-group>
                    <div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </div>
                    <div
                      class="mt-05 fs-12 text-left"
                      :class="couponCodeInfoColor"
                    >
                      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.16667 1.83333C7.22175 1.83333 5.35649 2.60595 3.98122 3.98122C2.60595 5.35649 1.83333 7.22175 1.83333 9.16667C1.83333 11.1116 2.60595 12.9769 3.98122 14.3521C5.35649 15.7274 7.22175 16.5 9.16667 16.5C11.1116 16.5 12.9769 15.7274 14.3521 14.3521C15.7274 12.9769 16.5 11.1116 16.5 9.16667C16.5 7.22175 15.7274 5.35649 14.3521 3.98122C12.9769 2.60595 11.1116 1.83333 9.16667 1.83333ZM0 9.16667C0 4.10392 4.10392 0 9.16667 0C14.2294 0 18.3333 4.10392 18.3333 9.16667C18.3333 14.2294 14.2294 18.3333 9.16667 18.3333C4.10392 18.3333 0 14.2294 0 9.16667ZM9.16667 13.75C9.40979 13.75 9.64294 13.6534 9.81485 13.4815C9.98676 13.3096 10.0833 13.0765 10.0833 12.8333V9.16667C10.0833 8.92356 9.98676 8.6904 9.81485 8.51849C9.64294 8.34658 9.40979 8.25 9.16667 8.25C8.92356 8.25 8.6904 8.34658 8.51849 8.51849C8.34658 8.6904 8.25 8.92356 8.25 9.16667V12.8333C8.25 13.0765 8.34658 13.3096 8.51849 13.4815C8.6904 13.6534 8.92356 13.75 9.16667 13.75ZM9.16667 4.58334C8.92356 4.58334 8.6904 4.67991 8.51849 4.85182C8.34658 5.02373 8.25 5.25689 8.25 5.5C8.25 5.74312 8.34658 5.97628 8.51849 6.14818C8.6904 6.32009 8.92356 6.41667 9.16667 6.41667H9.17584C9.41895 6.41667 9.65211 6.32009 9.82402 6.14818C9.99593 5.97628 10.0925 5.74312 10.0925 5.5C10.0925 5.25689 9.99593 5.02373 9.82402 4.85182C9.65211 4.67991 9.41895 4.58334 9.17584 4.58334H9.16667Z" fill="#28C76F"/>
                      </svg>
                      {{ couponCodeInfoText }}
                    </div>
                  </validation-provider>
                </b-form-group>

                <b-button
                  size="sm"
                  style="width: 140px"
                  class="btn-primary2"
                  variant="success"
                  :disabled="loading || invalid"
                  :loading="loading"
                  @click="applyCouponCode"
                >
                  {{ $t('Use') }}
                </b-button>
              </b-form>
            </validation-observer>
          </b-col>
        </b-row>
      </b-overlay>
    </b-modal>

    <b-modal
      v-model="modalCouponCodeSucceed"
      centered
      hide-header-close
      hide-footer
      hide-header
      size="sm"
    >
      <div
        class="d-flex justify-content-end fs-12 color-gray cursor-pointer"
        @click="modalCouponCodeSucceed = false"
      >
        {{ $t('Close') }}
      </div>
      <b-row>
        <b-col sm="12">
          <div class="d-flex flex-column justify-content-center text-center gap-12 mb-2">
            <div>
              <b-img
                :src="iconDiamonds3"
                width="140"
              />
            </div>
            <h1
              v-if="couponCodeBonusRatio"
              class="my-0"
            >
              {{ couponCodeBonusRatioText }}
            </h1>
            <div class="fs-20 text-center">
              {{ couponCodeResultText }}
            </div>
            <div v-if="!couponCodeBonusRatio">
              {{ $t('Have fun') }}!
            </div>
            <div
              v-else
              class="mt-05 fs-12 color-gray2"
            >
              <font-awesome-icon
                icon="fa-solid fa-info-circle"
              />
              {{ $t('Your bonuses will be added to your package after your diamond package purchase.') }}
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </section>
</template>

<script>
import {
  BButton, BCard, BCol, BForm, BFormGroup, BFormInput, BImg, BInputGroup, BModal, BOverlay, BRow, BSpinner, BTooltip,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import {
  gtmTrackNewEvent, showNotify, throwDefaultError, numberFormat, endsWithN,
} from '@/helpers/helpers'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import DynamicMarketInvite from './DynamicMarketInvite.vue'

const iconConfetti = require('@/assets/images/icons/confetti.png')
const iconHeart = require('@/assets/images/icons/heart-3.svg')
const iconTicket = require('@/assets/images/icons/ticket.svg')
const iconDiamonds1 = require('@/assets/images/icons/diamonds-1.svg')
const iconDiamonds2 = require('@/assets/images/icons/diamonds-2.svg')
const iconDiamonds3 = require('@/assets/images/icons/diamonds-3.svg')
const iconDiamonds3New = require('@/assets/images/icons/diamonds-3-new.svg')
const iconDiamonds3New2 = require('@/assets/images/icons/diamonds-3-new-2.svg')
const iconDiamonds4 = require('@/assets/images/icons/diamonds-4.svg')
const iconDiamonds5 = require('@/assets/images/icons/diamonds-5.svg')
const iconDiamonds6 = require('@/assets/images/icons/diamonds-6.svg')
const iconEnvelope1 = require('@/assets/images/icons/envelope-1.svg')
const iconEnvelope2 = require('@/assets/images/icons/envelope-2.svg')
const iconEnvelope3 = require('@/assets/images/icons/envelope-3.svg')
const iconEnvelope4 = require('@/assets/images/icons/envelope-4.svg')
const iconEnvelope5 = require('@/assets/images/icons/envelope-5.svg')
const iconEnvelope6 = require('@/assets/images/icons/envelope-6.svg')
const iconChat4 = require('@/assets/images/icons/chat-4.svg')
const iconChat5 = require('@/assets/images/icons/chat-5.svg')
const iconVip = require('@/assets/images/icons/vip.png')
const iconLounge = require('@/assets/images/icons/lounge.png')
const iconDailyDiamond = require('@/assets/images/icons/daily-diamond.png')

export default {
  components: {
    DynamicMarketInvite,
    BTooltip,
    BFormGroup,
    BForm,
    BInputGroup,
    BFormInput,
    BButton,
    BCard,
    BCol,
    BImg,
    BModal,
    BOverlay,
    BRow,
    BSpinner,

    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      appliedBonusCode: '',
      campaignCounters: [],
      campaignId: null,
      campaignsList: [],
      campaignType: null,
      chatProducts: [],
      creditsCharged: null,
      couponCode: '',
      couponCodeBonusRatio: null,
      couponCodeBonusRatioText: '',
      couponCodeInfoColor: 'color-gray',
      couponCodeInfoText: this.$t('Coupon is single use, not reusable'),
      couponCodeResultText: '',
      couponCodeSucceed: false,
      iconConfetti,
      iconHeart,
      iconTicket,
      iconDiamonds1,
      iconDiamonds2,
      iconDiamonds3,
      iconDiamonds3New,
      iconDiamonds3New2,
      iconDiamonds4,
      iconDiamonds5,
      iconDiamonds6,
      iconEnvelope1,
      iconEnvelope2,
      iconEnvelope3,
      iconEnvelope4,
      iconEnvelope5,
      iconEnvelope6,
      iconChat4,
      iconChat5,
      iconVip,
      iconLounge,
      iconDailyDiamond,
      loading: false,
      minCredits: null,
      modalBuyProduct: false,
      modalBuyChatProduct: false,
      modalCouponCode: false,
      modalCouponCodeSucceed: false,
      products: [],
      purchaseSource: null,
      showAllProducts: false,
      selectedChatProduct: null,
      selectedProduct: null,
      user: null,
    }
  },
  computed: {
    campaigns() {
      return this.campaignsList
    },
    credits() {
      return this.$store.getters['auth/credits']
    },
    userCountry() {
      return this.$store.getters['auth/userCountry']
    },
  },
  created() {
    // Purchase source'u localStorage'a ata
    this.purchaseSource = this.$route.params?.purchaseSource || 'web_market'
    if (this.purchaseSource) {
      localStorage.setItem('PURCHASE_SOURCE', this.purchaseSource)
    }

    this.getProducts()

    this.getCreditsCharged()

    this.getCampaigns()

    this.campaignId = this.$route.query.campaignId || null
    this.campaignType = this.$route.query.campaignType || null

    // Purchase source geldiyse ata
    this.purchaseSource = this.$route.params?.purchaseSource || null
  },
  mounted() {
    // app-content in arka planını değiştir
    this.changeAppContentBackground('#ffffff')
  },
  destroyed() {
    // app-content in arka planını değiştir
    this.changeAppContentBackground('#FFF')
  },
  methods: {
    currencySymbol(currency) {
      const code = String(currency || 'TRY').toUpperCase()
      return { TRY: '₺', USD: '$', EUR: '€' }[code] || code
    },
    // Sadece görünüm: kart renk teması (iş mantığına etkisi yok)
    packageTheme(product, index) {
      if (product && product.credits === 1000) return 'theme-popular'
      const themes = ['theme-blue', 'theme-violet', 'theme-green', 'theme-indigo', 'theme-pink', 'theme-gold']
      return themes[index % themes.length]
    },
    endsWithN,
    applyCouponCode() {
      this.loading = true

      useJwt.couponCodeToAddDiamond({ code: this.couponCode })
        .then(response => {
          const data = response.data.body

          if (data.valid) {
            this.couponCodeBonusRatio = null
            this.couponCodeBonusRatioText = ''
            this.couponCodeResultText = this.$t('The diamonds defined in your voucher have been loaded. You can check your diamonds on my profile page.')
            this.couponCode = ''
            this.appliedBonusCode = ''
            this.modalCouponCode = false
            this.modalCouponCodeSucceed = true
            this.loading = true
            useJwt.getMe()
              .then(response2 => {
                this.user = response2.data.body
                this.$store.dispatch('auth/updateUser', this.user)
              })
              .catch(error => {
                throwDefaultError(this.$toast, error)
              })
              .finally(() => { this.loading = false })
          } else if (data.bonusRatio) {
            this.modalCouponCode = false
            this.couponCodeBonusRatio = data.bonusRatio
            this.couponCodeBonusRatioText = `%${data.bonusRatio * 100}`
            this.couponCodeResultText = this.$t('A bonus of {ratio} has been added to your coupon. You can continue shopping.', { ratio: `%${data.bonusRatio * 100}` })
            this.appliedBonusCode = this.couponCode
            this.minCredits = data.minCredits
            this.couponCode = ''
            this.modalCouponCodeSucceed = true
          } else {
            // Kupon kodu geçerli değil
            this.couponCodeInfoColor = 'color-red-light'
            this.couponCodeInfoText = this.$t('You entered an incorrect or invalid coupon code. Check your details and try again. In case of problems, contact Boho Assistant.')
          }
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => { this.loading = false })
    },
    buyChatProduct() {
      this.loading = true
      useJwt.buyChatProduct({ productId: this.selectedChatProduct.productId })
        .then(() => {
          // eslint-disable-next-line no-underscore-dangle
          const _message = this.$t('You have successfully purchased product {product}', { product: this.selectedChatProduct.description })
          showNotify(this.$toast, _message, 'success')

          gtmTrackNewEvent('chatproductbuy', {
            category: 'ChatProductSelect',
            action: 'ChatProductBuySuccess',
            label: this.selectedChatProduct.productId,
          })

          setTimeout(() => {
            this.modalBuyChatProduct = false
            this.selectedChatProduct = null
          }, 11)
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)

          gtmTrackNewEvent('chatproductbuy', {
            category: 'ChatProductSelect',
            action: 'ChatProductBuyFail',
            label: this.selectedChatProduct.productId,
          })
        })
        .finally(() => { this.loading = false })
    },
    changeAppContentBackground(color) {
      setTimeout(() => {
        const appContent = document.querySelector('.app-content')
        if (appContent) {
          appContent.style.background = color
        }
      }, 11)
    },
    generateProductLink(productId, campaignId = null, campaignType = null) {
      const query = {}

      if (this.appliedBonusCode) {
        query['code'] = this.appliedBonusCode
        query['ratio'] = this.couponCodeBonusRatio
      }

      if (this.campaignId) {
        query['campaignId'] = this.campaignId
        query['campaignType'] = this.campaignType
      }

      if (campaignId) {
        query['campaignId'] = campaignId
      }

      if (campaignType) {
        query['campaignType'] = campaignType
      }

      return {
        name: 'buy',
        params: {
          productId,
          purchaseSource: this.purchaseSource,
        },
        query,
      }
    },
    getCampaigns() {
      useJwt.campaigns()
        .then(response => {
          this.$store.dispatch('app/setCampaigns', response.data.body)

          setTimeout(() => {
            this.initCampaigns()
          }, 11)
        })
    },
    getCreditsCharged() {
      useJwt.creditsCharged()
        .then(response => {
          this.creditsCharged = response.data.body
        })
    },
    getDiamondImage(product) {
      if (product.credits < 601) {
        return this.iconDiamonds1
      } if (product.credits < 1001) {
        return this.iconDiamonds2
      } if (product.credits < 1501) {
        return this.iconDiamonds3
      } if (product.credits < 2001) {
        return this.iconDiamonds4
      } if (product.credits < 2501) {
        return this.iconDiamonds5
      }

      return this.iconDiamonds6
    },
    getEnvelopeImage(product) {
      if (product.credits < 2001) {
        return this.iconEnvelope2
      } if (product.credits < 5001) {
        return this.iconEnvelope3
      } if (product.credits < 10001) {
        return this.iconEnvelope5
      }

      return this.iconEnvelope6
    },
    getProducts() {
      this.loading = true

      // eslint-disable-next-line no-underscore-dangle
      const _getProducts = useJwt.getProducts()
      // eslint-disable-next-line no-underscore-dangle
      const _getChatProducts = useJwt.getChatProducts()
      // eslint-disable-next-line no-underscore-dangle
      const _getMe = useJwt.getMe()

      Promise.all([_getProducts, _getChatProducts, _getMe])
        .then(values => {
          this.products = values[0].data.body.filter(p => p.paymentMethod === 'credit_card')

          this.chatProducts = values[1].data.body

          this.user = values[2].data.body
          this.$store.dispatch('auth/updateUser', this.user)
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => { this.loading = false })
    },
    gtmSelectProduct(id) {
      gtmTrackNewEvent('productselect', {
        category: 'Market',
        action: 'ProductSelect',
        label: id,
      })
    },
    initCampaigns() {
      const campaigns = this.$store.getters['app/campaigns']
      this.campaignsList = campaigns
        .filter(campaign => campaign.campaignType === 'ONE_TIME_OFFER')
        .map(campaign => {
          const result = {
            ...campaign,
            campaignCounter: null,
          }

          if (campaign.remainingCounter || campaign.paywallCounter) {
            let campaignCounterSeconds = (campaign.remainingCounter || campaign.paywallCounter) || 0
            campaignCounterSeconds *= 60
            campaignCounterSeconds -= 1

            this.updateCampaignCounter(result, campaignCounterSeconds)

            // Interval'ı başlat ve component unmount olduğunda temizle
            const campaignCounterInterval = setInterval(() => {
              if (campaignCounterSeconds > 0) {
                campaignCounterSeconds -= 1
                this.updateCampaignCounter(result, campaignCounterSeconds)
              } else {
                clearInterval(campaignCounterInterval)
              }
            }, 1000)

            // Component unmount olduğunda interval'ı temizle
            this.$once('hook:beforeDestroy', () => {
              clearInterval(campaignCounterInterval)
            })
          }

          return result
        })

      this.campaignsList.forEach(campaign => {
        useJwt.campaignsDisplayed({ campaignId: campaign.campaignId })
      })
    },
    updateCampaignCounter(campaign, totalSeconds) {
      const remainingDays = Math.floor(totalSeconds / (3600 * 24))
      const secondsInLastDay = totalSeconds % (3600 * 24) // Günlerden arta kalan saniyeler

      const remainingHours = Math.floor((secondsInLastDay / 3600)) + (remainingDays * 24)
      const remainingMinutes = Math.floor((secondsInLastDay % 3600) / 60)
      const remainingSeconds = secondsInLastDay % 60

      this.$set(campaign, 'campaignCounter', {
        days: remainingDays.toString(), // Günler için de formatlama yapabilirsiniz
        hours: remainingHours < 10 ? `0${remainingHours}` : remainingHours.toString(),
        minutes: remainingMinutes < 10 ? `0${remainingMinutes}` : remainingMinutes.toString(),
        seconds: remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds.toString(),
      })
    },
    numberFormat(value) {
      return numberFormat(value)
    },
    openBuyChatProduct(product) {
      this.modalBuyChatProduct = true
      this.selectedChatProduct = product

      gtmTrackNewEvent('chatproductselect', {
        category: 'ChatProductSelect',
        action: 'ChatProductSelect',
        label: product.productId,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#page-market {
  .product {
    cursor: pointer;
  }
  .row {
    margin-right: unset !important;
  }
  .title {
    display: block !important;
    width: 100% !important;
    margin-left: 8px;
    padding: 8px 8px 14px 0;
  }
  .market-title {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 19px;
    line-height: 22px;
    color: #000000;

    .colorized {
      color: #b513d0;
    }
  }
}

.diamond {
  position: relative;
  padding: 8px 0;
  //border: 1px solid #F5EEF0;
  background: #fff;
  box-shadow: 0 0 16px rgba(255, 255, 255, 0.5);
  border-radius: 24px;
  font-family: 'Lexend', sans-serif !important;
  font-style: normal;
  overflow: hidden;
  color: #000000;
  border: 2px solid #BBC6D1;

  &:has(.banner-counter-container) {
    overflow: visible !important;
  }

  .banner-counter-container {
    position: absolute;
    left: 0;
    top: -12px;
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: 999;

    .banner-counter {
      background-color: #6A00DC;
      color: #fff;
      font-size: 12px;
      padding: 4px 18px;
      border-radius: 18px;
    }
  }

  .discount-badge {
    position: absolute;
    left: 12px;
    top: 18px;
    color: #19E286;
    width: 80px;
    font-size: 12px;
    max-width: 52px !important;
  }

  .campaign-header {
    font-family: 'Lexend', sans-serif;
    font-size: 14px;
    font-weight: 500;
    padding: 4px 8px;
    text-align: center;
    margin-top: 8px;
    color: #272727;
  }

  .campaign-text {
    font-family: 'Lexend', sans-serif;
    font-size: 18px;
    font-weight: 700;
    padding: 4px 8px;
    text-align: center;
    margin-top: 8px;
    color: #000000;
  }

  .card-body {
    padding: 0;
  }

  .diamond-header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 6px;
    //background-color: #FFE8AD;
  }
  .diamond-body {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 4px;
    flex-direction: column;

    .diamond-piece {
      font-family: 'Inter', sans-serif;
      font-weight: 700;
      font-size: 15px;
      line-height: 22px;
      color: #000000;
      margin-bottom: 4px;
      text-align: center;
    }

    .diamond-description {
      font-weight: 300;
      font-size: 14px;
      line-height: 18px;
      color: #999;
      margin-bottom: 16px;
      text-align: center;
      max-width: 180px;
    }

    .diamond-price {
      font-family: 'Inter', sans-serif;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      background: linear-gradient(270deg, #AD32EF 8.57%, #EE0557 99.29%);
      border-radius: 100px;
      color: #fff;
      padding: 6px 16px;
      margin-bottom: 6px;
      text-align: center;
    }
  }

  .diamond-old-price {
    font-size: 11px;
    text-decoration: line-through;
    color: #949494;
  }
}

.special-offer {
  padding: 0;
  min-height: 300px;

  .card-body {
    padding: 0;
  }

  .bg-1 {
    background: url('../../assets/images/bg/special-offer-1.png') center center no-repeat
  }

  .bg-2 {
    background: url('../../assets/images/bg/special-offer-2.jpeg') center center no-repeat
  }

  .special-offer-header {
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: end;
    background-size: cover;
    min-height: 260px;
    padding: 14px;

    .special-offer-type, .special-offer-description {
      color: #fff;
    }
    .special-offer-type {
      font-weight: 300;
      font-size: 12px;
      line-height: 15px;
    }
    .special-offer-description {
      font-weight: 600;
      font-size: 18px;
      line-height: 22px;

    }
  }

  .special-offer-body {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    align-items: center;

    .special-offer-name {
      font-weight: 600;
      font-size: 18px;
      line-height: 22px;
    }
  }
}

.subscription-package {
  padding: 0;

  .card-body {
    padding: 14px;
  }

  .subscription-package-header {
    display: flex;

    .subscription-package-icon {
      margin-right: 8px;
    }

    .subscription-package-text {
      .subscription-package-title {
        .subscription-package-name {
          font-weight: 600;
          font-size: 18px;
          line-height: 22px;
        }
        .subscription-package-period {
          font-weight: 300;
          font-size: 12px;
          line-height: 15px;
          opacity: 0.3;
        }
      }
      .subscription-package-description {
        margin-top: 4px;
        font-weight: 300;
        font-size: 12px;
        line-height: 15px;
        opacity: 0.3;
      }
    }
  }
  .subscription-package-body {
    margin-top: 18px;
    display: flex;
    justify-content: center;
  }
}

.subscribe-button {
  display: inline-block;
  font-weight: 300;
  font-size: 14px;
  line-height: 18px;
  color: #000000;
  background: #E2E4E9;
  border-radius: 100px;
  padding: 10px 12px;
  cursor: pointer;
}

.buy-product-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.header-credits {
  margin-left: 0;

  .diamond-count {
    margin-left: 1px;
  }

  @media only screen and (max-width: 576px){
    .diamond-count{
      display: flex;
    }
  }
}

.color-red-light {
  color: #FC668A !important;
}
</style>

<style lang="scss" scoped>
/* =========================================================
   Yeni Market UI (sadece görünüm)
   ========================================================= */
#page-market {
  position: relative;
  padding: 18px 28px 40px;
  min-height: calc(100vh - 80px);

  @media (max-width: 991px) { padding: 14px 16px 32px; }
  @media (max-width: 575px) { padding: 10px 8px 24px; }
}

.mk-section {
  position: relative;
  z-index: 1;
  margin-bottom: 36px;
}

/* ---------- Başlık ---------- */
.mk-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.mk-title-wrap {
  display: flex;
  align-items: center;
  gap: 14px;
}

.mk-cart {
  display: inline-flex;
  filter: drop-shadow(0 0 10px rgba(168, 85, 247, 0.45));
}

.mk-title-bar {
  width: 4px;
  align-self: stretch;
  min-height: 52px;
  border-radius: 4px;
  background: linear-gradient(180deg, #a855f7, #6366f1);

  &.pink { background: linear-gradient(180deg, #ea03b2, #a855f7); min-height: 36px; }
}

.mk-title {
  color: #fff !important;
  font-size: 30px;
  font-weight: 800;
  line-height: 36px;
  margin: 0;
  letter-spacing: -0.3px;
}

.mk-subtitle {
  color: rgba(226, 220, 255, 0.75);
  font-size: 14px;
  margin: 4px 0 0;
}

.mk-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mk-coupon-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 9999px;
  padding: 9px 20px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  background: linear-gradient(135deg, #10b981, #22c55e);
  box-shadow: 0 6px 18px rgba(16, 185, 129, 0.35);
  cursor: pointer;
  transition: filter .15s ease, transform .15s ease;

  .mk-coupon-icon { filter: brightness(0) invert(1); }

  &:hover { filter: brightness(1.1); transform: translateY(-1px); }
}

.mk-balance {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 5px 5px 5px 14px;
  border-radius: 9999px;
  border: 1.5px solid rgba(251, 191, 36, 0.75);
  background: rgba(30, 20, 10, 0.35);
  box-shadow: 0 0 14px rgba(251, 191, 36, 0.18);

  img { filter: drop-shadow(0 0 4px rgba(251, 191, 36, 0.6)); }

  .mk-balance-amount {
    font-size: 16px;
    font-weight: 800;
    // Gradyan yazı (background-clip:text) bazen sarı kutu olarak görünüyordu; düz renk kullanılıyor
    color: #fcd34d;
    text-shadow: 0 0 8px rgba(251, 191, 36, 0.35);
  }

  .mk-balance-plus {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: linear-gradient(135deg, #f59e0b, #f97316);
  }
}

/* ---------- Paket kartları ---------- */
.mk-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 26px;
  padding-top: 14px;

  @media (max-width: 1399px) { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 30px 22px; }
  @media (max-width: 767px) { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 26px 14px; }
}

.mk-card {
  --c1: #3b82f6;
  --c2: #6366f1;
  --border: rgba(99, 102, 241, 0.6);
  --glow: rgba(99, 102, 241, 0.35);
  --btn: linear-gradient(135deg, #6d28d9, #4f46e5);
  --btn-shadow: rgba(99, 102, 241, 0.45);

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 26px 18px 22px;
  border-radius: 20px;
  border: 2px solid var(--border);
  background: linear-gradient(180deg, rgba(40, 30, 100, 0.65) 0%, rgba(20, 16, 56, 0.85) 100%);
  box-shadow: 0 10px 30px rgba(4, 2, 20, 0.45), 0 0 18px var(--glow);
  text-decoration: none !important;
  transition: transform .2s ease, box-shadow .2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 40px rgba(4, 2, 20, 0.55), 0 0 28px var(--glow);
  }

  &.theme-blue { --border: rgba(79, 70, 229, 0.75); --glow: rgba(79, 70, 229, 0.3); --btn: linear-gradient(135deg, #6d28d9, #4338ca); --btn-shadow: rgba(79, 70, 229, 0.5); }
  &.theme-violet { --border: rgba(124, 58, 237, 0.7); --glow: rgba(124, 58, 237, 0.3); --btn: linear-gradient(135deg, #a21caf, #7c3aed); --btn-shadow: rgba(147, 51, 234, 0.5); }
  &.theme-green { --border: rgba(16, 185, 129, 0.7); --glow: rgba(16, 185, 129, 0.3); --btn: linear-gradient(135deg, #059669, #4f46e5); --btn-shadow: rgba(16, 185, 129, 0.45); }
  &.theme-indigo { --border: rgba(168, 85, 247, 0.75); --glow: rgba(168, 85, 247, 0.32); --btn: linear-gradient(135deg, #9333ea, #6366f1); --btn-shadow: rgba(147, 51, 234, 0.5); }
  &.theme-pink { --border: rgba(219, 39, 119, 0.8); --glow: rgba(219, 39, 119, 0.32); --btn: linear-gradient(135deg, #db2777, #c026d3); --btn-shadow: rgba(219, 39, 119, 0.5); }
  &.theme-gold {
    --border: rgba(245, 158, 11, 0.85);
    --glow: rgba(245, 158, 11, 0.3);
    --btn: linear-gradient(135deg, #f59e0b, #eab308);
    --btn-shadow: rgba(245, 158, 11, 0.5);
    background: linear-gradient(180deg, rgba(70, 42, 20, 0.6) 0%, rgba(28, 18, 30, 0.88) 100%);
  }
  &.theme-popular {
    --border: #2ee6a6;
    --glow: rgba(46, 230, 166, 0.45);
    --btn: linear-gradient(135deg, #ff1f8f, #7c3aed);
    --btn-shadow: rgba(255, 31, 143, 0.5);
    background: linear-gradient(180deg, rgba(14, 60, 64, 0.65) 0%, rgba(14, 22, 52, 0.9) 100%);
    transform: scale(1.04);

    &:hover { transform: scale(1.04) translateY(-4px); }

    @media (max-width: 767px) { transform: none; &:hover { transform: translateY(-4px); } }
  }
}

.mk-card-glow {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: radial-gradient(ellipse 70% 45% at 50% 22%, var(--glow), transparent 70%);
  pointer-events: none;
}

.mk-popular {
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 16px;
  border-radius: 9999px;
  white-space: nowrap;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .3px;
  background: linear-gradient(135deg, #ff1f8f, #a855f7);
  box-shadow: 0 4px 14px rgba(255, 31, 143, 0.45);
  z-index: 3;
}

.mk-discount {
  position: absolute;
  top: 16px;
  left: 0;
  max-width: 62px;
  padding: 7px 10px;
  border-radius: 0 10px 10px 0;
  color: #34d399;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  background: rgba(16, 185, 129, 0.16);
  z-index: 2;

  ::v-deep b,
  ::v-deep strong,
  ::v-deep span { color: #fff; }
}

.mk-gem {
  position: relative;
  z-index: 1;
  height: 92px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;

  img {
    filter: drop-shadow(0 6px 14px var(--glow)) drop-shadow(0 0 10px rgba(251, 191, 36, 0.35));
  }

  &.small { height: 70px; margin-bottom: 0; }
}

.mk-amount {
  position: relative;
  z-index: 1;
  color: #fff;
  font-size: 22px;
  font-weight: 800;
  line-height: 28px;
  text-align: center;
  margin-bottom: 6px;

  @media (max-width: 575px) { font-size: 17px; line-height: 22px; }
}

.mk-old-price {
  position: relative;
  z-index: 1;
  color: rgba(226, 220, 255, 0.55);
  font-size: 15px;
  font-weight: 600;
  text-decoration: line-through;
  margin-bottom: 16px;
}

.mk-price-btn {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 230px;
  margin-top: auto;
  padding: 12px 10px;
  border-radius: 9999px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  font-weight: 800;
  background: var(--btn);
  box-shadow: 0 8px 20px var(--btn-shadow), inset 0 1px 0 rgba(255, 255, 255, 0.25);

  @media (max-width: 575px) { font-size: 16px; padding: 10px 8px; }
}

/* ---------- Daha fazla yükle ---------- */
.mk-load-more {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 34px;

  .mk-load-line {
    flex: 0 1 180px;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(170, 140, 255, 0.45), transparent);
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-direction: row-reverse;
    background: transparent;
    border: 0;
    color: rgba(226, 220, 255, 0.8);
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;

    &:hover { color: #fff; }
  }
}

/* ---------- Kampanyalar ---------- */
.mk-campaign-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 22px;
}

.mk-campaign {
  --glow: rgba(234, 3, 178, 0.3);
  --btn: linear-gradient(135deg, #ff1f8f, #7c3aed);
  --btn-shadow: rgba(255, 31, 143, 0.45);

  position: relative;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 26px 22px 22px;
  border-radius: 20px;
  border: 2px solid rgba(234, 3, 178, 0.55);
  background: linear-gradient(160deg, rgba(60, 20, 90, 0.7) 0%, rgba(20, 16, 56, 0.9) 100%);
  box-shadow: 0 10px 30px rgba(4, 2, 20, 0.45), 0 0 18px var(--glow);
  text-decoration: none !important;
  transition: transform .2s ease;

  &:hover { transform: translateY(-4px); }

  .mk-price-btn { max-width: none; }
}

.mk-counter {
  position: absolute;
  top: -13px;
  right: 18px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 12px;
  border-radius: 9999px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  background: linear-gradient(135deg, #f59e0b, #ef4444);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
  z-index: 2;
}

.mk-campaign-body {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 16px;
}

.mk-campaign-title {
  color: #fff !important;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 4px;
}

.mk-campaign-text {
  color: rgba(236, 232, 255, 0.85);
  font-size: 14px;
  line-height: 20px;
  margin: 0;
}

/* ---------- Alt dalgalar ---------- */
.mk-waves {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 240px;
  pointer-events: none;
  z-index: 0;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
}


@media (max-width: 575px) {
  .mk-header { margin-bottom: 22px; }
  .mk-title { font-size: 22px; line-height: 28px; }
  .mk-subtitle { font-size: 12px; }
  .mk-cart svg { width: 34px; height: 34px; }
  .mk-title-bar { min-height: 40px; }
  .mk-header-actions { width: 100%; justify-content: space-between; }
  .mk-card { padding: 22px 10px 16px; }
  .mk-gem { height: 72px; margin-bottom: 10px; img { width: 68px; } }
  .mk-popular { font-size: 10px; padding: 4px 10px; }
  .mk-discount { top: 10px; max-width: 54px; padding: 5px 7px; font-size: 10px; line-height: 13px; }
  .mk-old-price { font-size: 13px; margin-bottom: 12px; }
  .mk-campaign-grid { grid-template-columns: 1fr; }
}
</style>
